// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gh-compass{margin-right:.5rem}.gh-nav{box-shadow:0 0 10px rgba(30,61,111,.08)}.gh-accordion{display:block}.gh-popovers{display:none}.gh-icon{height:20px}.gh-popoverTrigger>button{line-height:20px}.gh-popoverTrigger>button:focus{outline:1px solid transparent}@media screen and (min-width:768px){.gh-nav{box-shadow:none;display:flex}.gh-accordion{display:none}.gh-popovers{display:flex}}", ""]);
// Exports
module.exports = exports;
